// base
import React, { useEffect, useRef, useState } from 'react';

// libraries
import gsap from 'gsap';
import { useGLTF } from '@react-three/drei';

useGLTF.preload('/assets/models/icons/failuare_shield/failuare_shield.gltf');

export const FailuareShield = (props) => {
  const failuareRef = useRef();

  const [hovered, setHovered] = useState(false);

  const { scene, nodes, materials } = useGLTF(
    '/assets/models/icons/failuare_shield/failuare_shield.gltf'
  );

  useEffect(() => {
    scene.traverse((mesh) => {
      mesh.castShadow = true;
      mesh.receiveShadow = true;
    });

    if (!failuareRef.current) return;

    gsap.to(failuareRef.current.rotation, {
      duration: 3,
      repeat: -1,
      yoyo: false,
      ease: 'none',
      y: Math.PI * 2
    });

    gsap.to(failuareRef.current.scale, {
      duration: 0.5,
      x: hovered ? 0.75 : 0.55,
      y: hovered ? 0.75 : 0.55,
      z: hovered ? 0.75 : 0.55
    });
  }, [hovered]);

  return (
    <group
      {...props}
      dispose={null}
      ref={failuareRef}
      scale={[0.55, 0.55, 0.55]}
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
    >
      <group position={[0, 56.154, 0]}>
        <mesh
          geometry={nodes.shield_v2.geometry}
          material={materials.color}
          rotation={[-Math.PI / 2, 0, 0]}
        />
      </group>
    </group>
  );
};
